export default __webpack_public_path__ + "static/media/Slider-3.ca74e8e4.png";